export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    wantToLoseWeight: null,
    milkAllergy: null,
    privacyAgreement: null,
    weightLossReceive: null,
    email: null,
  },
})
